import { useEffect, useState } from "react";
import { FaCheckDouble } from "react-icons/fa";
import { getRecentCompletions } from "../../services/apiClient.js";

// The "you just handled X" one-liner (docs/badge-activity-tracking.md). Fully
// self-contained: reads the signed-in user's OWN recent badge completions and
// renders nothing when there are none, so it's safe to drop on any page. The
// feedback loop — clear a badge on a claim → come back to the list → see it.
function RecentCompletions({ minutes = 10 }) {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getRecentCompletions(minutes).then(setItems).catch(() => {});
  }, [minutes]);

  if (dismissed || items.length === 0) return null;
  return (
    <div className="recent-completions d-flex align-items-center gap-2 mb-3">
      <FaCheckDouble className="flex-shrink-0" />
      <span>
        <span className="fw-semibold">
          You handled {items.length} needs-attention item{items.length === 1 ? "" : "s"} recently:
        </span>{" "}
        {items.map((it, i) => (
          <span key={i}>
            {i > 0 ? " · " : ""}
            {it.label}
            {it.claim_number ? ` (#${it.claim_number})` : ""}
          </span>
        ))}
      </span>
      <button
        type="button"
        className="btn-close ms-auto flex-shrink-0"
        style={{ fontSize: "0.7rem" }}
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      />
    </div>
  );
}

export default RecentCompletions;
